module.exports = __webpack_public_path__ + "9a958401fd126a3c08686ece9477cea3.svg";